/* Dansk katalog for locale-completion-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  "common.rowUnavailable": "Data kunne ikke indl?ses. Pr?v igen.",
  "common.rowContextChanged": "Den valgte virksomhed eller det valgte dokument er ?ndret. ?bn det igen.",
  "common.bankStatementIncomplete": "Kontoudtoget er ikke indl?st helt. Pr?v igen.",
  "common.journalProofUnavailable": "Regnskabsgrundlaget kunne ikke verificeres.",

  'pay.employeesAwaitingPayment': '{{count}} medarbejdere venter på udbetaling',
  'pay.readyForPayment': 'Klar til udbetaling',
  'pay.readyForPaymentHelp': 'Godkendte og bogførte lønkørsler, som stadig har løn, der ikke er registreret som udbetalt.',
  'pay.noRunsAwaitingPayment': 'Ingen lønkørsler venter på udbetaling',
  'pay.noRunsAwaitingPaymentHint': 'Godkendte lønkørsler vises her, indtil udbetalingen er registreret.',
  'pay.draftPayrollRuns': 'Kladder',
  'pay.noDraftPayrollRuns': 'Ingen lønkladder.',
  'buy.ownerOutlay': 'Udlæg fra ejer',
  'home.followup.assetPostingTitle': 'Afskrivninger',
  'home.followup.assetPostingAction': 'Se afvigelse',
  'home.followup.assetPostingIssue': 'Automatisk afskrivning kræver opfølgning. Kontrollér aktivets plan, eller kontakt support. Plumme prøver igen, når afvigelsen er rettet.',
  'ui.cancel': 'Annuller',
  'ui.close': 'Luk',
  'ui.back': 'Tilbage',
  'ui.continue': 'Fortsæt',
  'ui.open': 'Åbn',
  'app.close': 'Luk',
  'common.loadMore': 'Indl?s flere', 'common.loading': 'Indlæser...',
  'shell.collapse': 'Skjul menu',
  'chat.cardFromFirm': 'Bogholderen skrev',
  'chat.cardFromYou': 'Du skrev',
  'chat.cardNone': 'Ingen beskeder endnu',
  'chat.firm': 'Din bogholder',
  'chat.helpTitle': 'Din bogholder',
  'chat.help': 'Skriv direkte til din bogholder. Kun du som ejer eller administrator kan se denne samtale.',
  'chat.cardOpenUnread': 'Læs beskeden',
  'chat.cardOpen': 'Send en besked',
  'chat.modalTitle': 'Du har en ulæst besked',
  'chat.modalOpen': 'Åbn chat',
  'chat.modalBody': 'har sendt dig en besked, som du ikke har læst.',
  'chat.client': 'Klienten',
  'chat.subFirm': 'Dialog med klienten',
  'chat.subClient': 'Dialog med din bogholder',
  'chat.emptyFirm': 'Ingen beskeder endnu. Skriv til klienten her — de ser den i Plumme.',
  'chat.emptyClient': 'Ingen beskeder endnu. Spørg din bogholder om det, du er i tvivl om.',
  'chat.placeholder': 'Skriv en besked …',
  'chat.send': 'Send',
  'rf.client.takeoverSaved': 'Overtagelsesdatoen er gemt',
  'rf.client.takeover': 'Overtagelsesdato',
  'rf.client.takeoverHelp': 'Perioder og frister før denne dato regnes ikke som bureauets arbejde. Klientens egen pligt ændres ikke.',
  'rf.client.takeoverSave': 'Gem dato',
  'clo.cash.invalidAmount': 'Indtast den optalte kassebeholdning.',
  'clo.cash.documentationRequired': 'Beskriv dokumentationen for optællingen, før du godkender.',
  'clo.cash.saved': 'Kasseoptællingen er gemt.',
  'clo.cash.saveError': 'Kunne ikke gemme kasseoptællingen.',
  'clo.cash.title': 'Mønter og sedler',
  'clo.cash.readySubtitle': 'Kassebeholdningen er optalt og stemmer med konto 1900.',
  'clo.cash.naSubtitle': 'Der er ikke registreret nogen kassebeholdning på konto 1900.',
  'clo.cash.todoSubtitle': 'Optæl kassebeholdningen pr. 31.12, og sammenlign med konto 1900.',
  'clo.cash.noStatus': 'Kassestatus er ikke beregnet endnu.',
  'clo.cash.booked': 'Bogført på 1900',
  'clo.cash.counted': 'Optalt pr. 31.12',
  'clo.cash.difference': 'Difference',
  'clo.cash.countedField': 'Optalt kassebeholdning',
  'clo.cash.account': 'Kassekonto',
  'clo.cash.documentation': 'Dokumentation for optællingen',
  'clo.cash.documentationPlaceholder': 'For eksempel: Kassen optalt 31.12 af den administrerende direktør. Optællingsskemaet er gemt i bilagsmappen.',
  'clo.cash.noDifferenceHelp': 'Når den optalte beholdning stemmer med konto 1900, gemmes optællingen som dokumentation uden ekstra postering.',
  'clo.cash.surplusHelp': 'Differencen øger konto 1900 og bogføres mod anden indtægt.',
  'clo.cash.shortageHelp': 'Differencen reducerer konto 1900 og bogføres mod anden omkostning.',
  'clo.cash.approve': 'Godkend optælling',
  'clo.chart.suggestionsReady': 'Forslagene er klar til godkendelse.',
  'clo.chart.noSuggestions': 'Fandt ingen sikre forslag.',
  'clo.chart.pickBeforeApprove': 'Vælg standardkonto, før du godkender.',
  'clo.chart.saved': '{{count}} kontokoblinger gemt',
  'clo.chart.saveError': 'Kunne ikke gemme kontokoblingerne.',
  'clo.chart.title': 'Kontoplan',
  'clo.chart.missingSubtitle': '{{count}} egne konti mangler kobling til standardkonto.',
  'clo.chart.readySubtitle': 'Kontoplanen er klar til årsafslutning.',
  'clo.chart.allMapped': 'Alle brugerdefinerede konti er koblet til standardkonto.',
  'clo.chart.instructions': 'Vælg, hvilken standardkonto hver egen konto svarer til.',
  'clo.chart.aiSuggest': 'AI finder forslag',
  'clo.chart.accountFallback': 'Konto {{code}}',
  'clo.chart.missingMapping': 'Mangler standardkobling',
  'clo.chart.equivalent': 'Svarer til standardkonto',
  'clo.chart.reset': 'Nulstil forslag',
  'clo.chart.approve': 'Godkend {{count}} forslag',
  'clo.share.title': 'Aktiekapital',
  'clo.share.readySubtitle': 'Aktiekapitalen er bogført på konto 2000.',
  'clo.share.missingSubtitle': 'Kontrollér eller bogfør aktiekapitalen, før årsafslutningen fuldføres.',
  'clo.share.noStatus': 'Aktiekapitalstatus er ikke beregnet endnu.',
  'clo.share.booked': 'Bogført på 2000',
  'clo.share.minimum': 'Minimum for norsk AS',
  'clo.share.lossNote': 'Underskud eller tabt egenkapital skal normalt ikke føres bort fra konto 2000. Det vurderes under egenkapital, resultatdisponering og fortsat drift. Dette punkt kontrollerer kun, at registreret aktiekapital er bogført som kredit på 2000.',
  'clo.share.freePosting': 'Bogfør aktiekapital',
  'sharedText.app.employeePortalVerifyTitle': 'Bekræft din e-mailadresse',
  'sharedText.auth.remember': 'Husk mig',
  'sharedText.auth.noAccount': 'Har du ikke en konto?',
  'sharedText.auth.forgotCopy': 'Indtast den e-mail, du logger ind med, så sender vi dig et link til at oprette en ny adgangskode.',
  'sharedText.acc.sentLinkTo': 'Vi har sendt et link til',
  'sharedText.rep.export.year': 'År',
  'sharedText.bank.previewVoucher': 'Forhåndsvis bilaget',
  'sharedText.km.returnTrip': 'Tur/retur',
  'sharedText.pay.paidOut': 'Udbetalt',
  'sharedText.inv.col.net': 'Netto',
  'sharedText.transaction.by': 'af',
  'sharedText.buy.pickCategory': 'Konto/kategori',
  'sharedText.vat.vat': 'Moms',
  'sharedText.sup.seeVoucher': 'Se bilag',
  'sharedText.bwf.correctEntry': 'Ret postering',
  'sharedText.ap.approve': 'Godkend',
  'sharedText.sale.pay.partialStatusRemaining': 'mangler',
  'sharedText.helpTopics.ocrCorrection.title': 'Ret aflæsning',
  'sharedText.pay.note': 'Note',
  'sharedText.bank.openingBalance': 'Primosaldo',
  'sharedText.asset.closing': 'Ultimosaldo',
  'sharedText.sale.att.dropHere': 'Slip bilaget her',
  'sharedText.voucher.pickAccount': 'Vælg konto',
  'sharedText.adv.scn.plan.interest': 'Renter',
  'sharedText.sale.pay.fee': 'Gebyr',
  'sharedText.ui.cancel': 'Annuller',
  'sharedText.bwf.selectLine': 'Vælg banklinje',
  'sharedText.bg.bankLines': 'Banklinjer',
  'sharedText.home.ana.ring': 'Fordeling',
  'sharedText.pj.row.new': 'Ny række',
  'sharedText.bank.bankLine': 'Banklinje',
  'sharedText.helpTopics.openItem.title': 'Åben post',
  'sharedText.clo.amount': 'Beløb',
  'sharedText.adv.status.more': 'Flere valg',
  'sharedText.inboxStatus.dropReceipts': 'Slip bilagene her',
  'sharedText.bank.uploading': 'Uploader …',
  'sharedText.set.showAll': 'Vis alle',
  'sharedText.bank.voucherReceivedOn': 'Bilag modtaget på',
  'sharedText.set.acc.lines': 'linjer',
  'sharedText.nav.budget': 'Budget',
  'sharedText.bud.actual': 'Faktisk',
  'sharedText.ui.close': 'Luk',
  'sharedText.pay.signOut': 'Log ud',
  'sharedText.rf.group.firm': 'Bogholder',
  'sharedText.rf.create.title': 'Opret bogholderibureau',
  'sharedText.ui.open': 'Åbn',
  'sharedText.buy.next': 'Næste',
  'sharedText.adv.docs.hide': 'Skjul',
  'sharedText.fe.decline': 'Afvis',
  'sharedText.common.yes': 'Ja',
  'sharedText.ap.review.checked': 'Kontrolleret',
  'sharedText.clo.pick': 'Vælg',
  'sharedText.nav.taxReturn': 'Skattemelding',
  'sharedText.clo.financialYear': 'Regnskabsåret',
  'sharedText.helpTopics.residualValue.title': 'Restværdi',
  'sharedText.clo.inventoryReview.undecided': 'Vælg vurdering',
  'sharedText.helpTopics.readyForUse.title': 'Klar til brug',
  'sharedText.asset.work.residualValue': 'Forventet restværdi',
  'sharedText.inv.credit.line': 'Linje',
  'sharedText.buy.paid': 'Betalt',
  'sharedText.km.from': 'Fra',
  'sharedText.km.to': 'Til',
  'sharedText.set.accountNo': 'Kontonr.',
  'sharedText.sale.credit.previewReason': 'Årsag:',
  'sharedText.clo.description': 'Beskrivelse',
  'sharedText.prd.price': 'Pris',
  'sharedText.clo.sum': 'Sum',
  'sharedText.inv.kpi.sub.exVat': 'Ekskl. moms',
  'sharedText.set.page': 'Side',
  'sharedText.sale.cust.org': 'Org.nr.',
  'sharedText.trv.vehicle': 'Køretøj',
  'sharedText.ap.monthControl.finding.deviation': 'Mulig afvigelse',
  'sharedText.vat.cancel': 'Annuller',
  'sharedText.bank.review': 'Kontrollér',
  'sharedText.inbox.supplierInvoice': 'Leverandørfaktura',
  'sharedText.bank.roundingHelp': 'Brug kun dette til en reel lille afrundingsdifference. Beløbet bogføres uden moms mod',
  'sharedText.trv.reason': 'Begrundelse',
  'sharedText.set.acc.vatRegisteredPick': 'Vælg svar',
  'sharedText.set.acc.vatRegisteredUnknown': 'Ved ikke',
  'sharedText.set.acc.vatRegisteredFrom': 'Momsregistreret fra',
  'sharedText.vat.due': 'Frist',
  'sharedText.pay.advance': 'Forskud',
  'sharedText.pay.aga': 'AGA',
  'sharedText.inv.col.number': 'Nr.',
  'sharedText.onb.createPersonal': 'Opret din privatøkonomi',
  'sharedText.onb.createPersonalHelp': 'Dette opretter en separat privatøkonomi-bruger, som du finder via Min side og brugervælgeren.',
  'sharedText.onb.noBankData': 'Bankforbindelsen er ikke aktiv endnu. Du kan uploade kontoudtog manuelt, når du ønsker det.',
  'sharedText.po.youHaveStated': 'Du har oplyst, at',
  'sharedText.po.wealthStrongestOn': 'Din formue scorer højest på',
  'sharedText.po.withYourAssumptions': 'Med de forudsætninger, du har indtastet, ændrer din formue sig med omkring',
  'sharedText.po.splitIsEven': 'Fordelingen er ligelig. I deler',
  'sharedText.po.householdHasRegistered': 'Husstanden har registreret',
  'sharedText.po.budgetTotal': 'Sum budget:',
  'sharedText.set.bank.typeTax': 'Skattetræk',
  'sharedText.clo.no': 'Nej',
  'sharedText.po.showingScenario': 'Viser scenarie:',
  'sharedText.po.desiredNetWealth': 'Ønsket nettoformue',
  'sharedText.po.lastsUntilYouAre': 'rækker, til du er',
  'sharedText.sd.transition.years': 'år',
  'sharedText.po.lasts': 'rækker',
  'sharedText.po.prioritise': 'Prioritér',
  'sharedText.adv.scn.loan.monthsUnit': 'md.',
  'sharedText.po.doYouWantToDelete': 'Vil du slette',
  'sharedText.po.householdSpends': 'Husstanden bruger',
  'sharedText.po.iRecommend': 'Jeg anbefaler',
  'sharedText.po.debtFree': 'Gældfri',
  'sharedText.po.interestPostedAs': 'Renter og afdrag på dette lån føres som',
  'sharedText.helpTopics.buffer.title': 'Likviditetsbuffer',
  'sharedText.clo.save': 'Gem',
  'sharedText.adv.profile.buffer': 'Ønsket buffer',
  'sharedText.home.legend.income': 'Indtægt',
  'sharedText.set.bank.typeSavings': 'Opsparing',
  'sharedText.pay.category': 'Kategori',
  'sharedText.set.account': 'Konto',
  'sharedText.po.allAccounts': 'Alle konti',
  'sharedText.adv.status.snooze7': 'Mind mig om en uge',
  'sharedText.po.yourHealthScoreIs': 'Din sundhedsscore er',
  'sharedText.po.outOf100': 'ud af 100',
  'sharedText.po.taxAssistant': 'Skattemeldingsassistent',
  'sharedText.cust.prev': 'Forrige',
  'sharedText.bank.finishReview': 'Fuldfør gennemgang',
  'sharedText.po.checkBasis': 'Kontrolgrundlag',
  'sharedText.clo.name': 'Navn',
  'sharedText.set.text': 'Tekst',
  'sharedText.sale.textLine.boldShort': 'F',
  'sharedText.sale.textLine.italicShort': 'K',
  'sharedText.sale.lines.useDivider': 'Brug skillelinje',
  'sharedText.sale.textLine.dividerHint': 'Vis en linje under teksten i dokumentet.',
  'sharedText.nav.products': 'Produkter',
  'sharedText.sale.textLine.titleNewText': 'Ny tekstlinje',
  'sharedText.prd.deleted': 'Slettet',
  'sharedText.pay.edit': 'Redigér',
  'sharedText.clo.delete': 'Slet',
  'sharedText.set.loans.startDate': 'Startdato',
  'sharedText.helpTopics.unitCost.title': 'Kostpris pr. enhed',
  'sharedText.pay.optional': 'Valgfrit',
  'sharedText.registry.group': 'Produktgruppe',
  'sharedText.clo.add': 'Tilføj',
  'sharedText.ha.products.account': 'Indtægtskonto',
  'sharedText.clo.accountNumber': 'Kontonummer',
  'sharedText.clo.accountName': 'Kontonavn',
  'sharedText.buy.supplierNew': 'Ny leverandør',
  'sharedText.auth.createAccount': 'Opret konto',
  'sharedText.set.acc.equivalent': 'Svarer til konto',
  'sharedText.bwf.entry': 'Postering',
  'sharedText.sale.att.upload': 'Upload vedhæftning',
  'sharedText.vat.settlement': 'Afregning',
  'sharedText.ap.agent.invoice.selectRow': 'Vælg faktura',
  'sharedText.ap.workspace.treatmentAsset': 'Registrér som driftsmiddel',
  'sharedText.bank.receiptLinked': 'Tilknyttet banklinje',
  'sharedText.sd.documents.count': 'dokumenter',
  'sharedText.set.debit': 'Debet',
  'sharedText.set.bank.accounts': 'Bankkonti',
  'sharedText.sd.deleteBusinessHelp': 'Slet virksomhed fjerner den valgte virksomhed efter 30 dage via backend. Dette er en alvorlig handling.',
  'sharedText.vat.rate': 'Sats',
  'sharedText.inv.bulk.noEmail': 'mangler e-mail',
  'sharedText.trv.privateRefundOf': 'Privat refusion af',
  'sharedText.asset.group': 'Gruppe',
  'sharedText.asset.opening': 'Indgående',
  'sharedText.asset.movements': 'Bevægelser',
  'sharedText.set.credit': 'Kredit',
  'sharedText.voucher.backToVat': 'Tilbage til MVA-meldingen',
  'sharedText.vat.vatCode': 'Momskode',
  'sharedText.bank.markVoucherLostTitle': 'Markér bilag som bortkommet',
  'sharedText.bank.voucherLostReason': 'Forklaring',
  'pay.salaryLineDeleted': 'Lønlinjen er slettet.',
  'pay.salaryLineNotFound': 'Lønlinjen findes ikke længere.',
  'pay.deleteSalaryLine': 'Slet lønlinje',
  'pay.deleteSalaryLineConfirm': 'Vil du slette »{{name}}« fra dette lønudkast?',
  'pay.accountingVouchers': 'Regnskabsbilag',
  'pay.payrollVoucher': 'Lønbilag',
  'pay.paymentVoucher': 'Betalingsbilag',
  'pay.paymentVoucherInDifferentYear': 'Betalingen er bogført i {{year}} og vises derfor i saldobalancen for det år.',
  'pay.settleSalaryLiability': 'Afregning af skyldig løn',
  'pay.settleEmployeeExpense': 'Afregning af udlæg',
  'pay.paymentFromBank': 'Udbetaling fra bankkonto',
});
